"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function hasFieldMappings(value) {
    return lodash_1.isString(value) && lodash_1.includes(value, '{{') && lodash_1.includes(value, '}}');
}
exports.default = hasFieldMappings;
